// extracted by mini-css-extract-plugin
export default {"main":"Invoice_main__aOegO","header":"Invoice_header__3y0H-","details":"Invoice_details__r9VvP"};